'use client';

import { block as _block$ } from "million/react-server";
import { useEffect } from 'react';
const M$GlobalError = function GlobalError({
  error,
  reset
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  return <html lang="en">
      <head>
      </head>
      <body>
        <h2>Something went wrong!</h2>
        <button onClick={() => reset()}>Try again</button>
      </body>
    </html>;
};
const GlobalError = M$GlobalError;
export default GlobalError;